/* WS-FUNNEL: dismissible in-article signup. WS-FUNNEL2: desktop-only exit-intent quiz offer. No dependencies. */
(function () {
  'use strict';
  var KEY = 'fnl_mail_dismissed';
  function stored() { try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function remember() { try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function init() {
    var boxes = document.querySelectorAll('[data-fnl-dismissible]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        var btn = box.querySelector('[data-fnl-dismiss]');
        var posted = /customer_posted=true/.test(window.location.search);
        if (stored() && !posted) { box.hidden = true; return; }
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () { box.hidden = true; remember(); });
        }
      })(boxes[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* WS-FUNNEL2: exit-intent quiz offer. Desktop only (>=1100px, hover + fine pointer), once per session, never on mobile.
   Armed only after 20 s on the page AND 25% scroll depth. Skipped when: the reader already has a quiz plan, has clicked any Plentum CTA, is typing in a form, or has dismissed the sticky bar.
   Non-blocking: no layout shift (fixed overlay), Esc and the scrim close it, focus returns to where it was. */
(function () {
  'use strict';
  var d = document, w = window, KEY = 'fnl_exit_seen';
  function store(fn) { try { return fn(w.sessionStorage); } catch (e) { return null; } }
  function init() {
    var box = d.querySelector('[data-fnl-exit]');
    if (!box || !w.matchMedia || !w.matchMedia('(min-width: 1100px) and (hover: hover) and (pointer: fine)').matches) return;
    if (store(function (s) { return s.getItem(KEY); }) === '1') return;
    try { if (w.localStorage.getItem('plentum_plan_v1')) return; } catch (e) {}
    var dlg = box.querySelector('[role="dialog"]'), t0 = Date.now(), maxDepth = 0, shown = false, last = null;
    function depth() { var h = d.documentElement.scrollHeight - w.innerHeight; return h > 0 ? (w.pageYOffset || d.documentElement.scrollTop) / h : 0; }
    w.addEventListener('scroll', function () { var v = depth(); if (v > maxDepth) maxDepth = v; }, { passive: true });
    function suppress() { store(function (s) { s.setItem(KEY, '1'); }); }
    function close() {
      box.hidden = true; shown = false; d.removeEventListener('keydown', onKey, true);
      if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) {} }
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = box.querySelectorAll('a[href], button'); if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && d.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
    d.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('[data-pl-cta]'); if (a && !box.contains(a)) suppress(); }, true);
    box.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-fnl-exit-close]')) close(); });
    d.addEventListener('mouseout', function (e) {
      if (shown || e.relatedTarget || e.clientY > 0) return;
      if (Date.now() - t0 < 20000 || maxDepth < 0.25) return;
      var a = d.activeElement; if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;
      if (store(function (s) { return s.getItem('blg_bar_closed'); }) === '1') return;
      if (store(function (s) { return s.getItem(KEY); }) === '1') return;
      shown = true; suppress(); last = d.activeElement;
      box.hidden = false; d.addEventListener('keydown', onKey, true);
      if (dlg) dlg.focus();
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* T-FUNNEL21: funnel click tracking. Every funnel CTA carries data-funnel (slot) and data-funnel-formula (product handle or quiz).
   Publishes the Shopify custom event "plentum_funnel_click" (readable by a custom web pixel) when Shopify.analytics.publish exists; the data attributes stay in the DOM either way. No UTMs on internal links. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-funnel]'); if (!a) return;
    try {
      var S = window.Shopify;
      if (S && S.analytics && typeof S.analytics.publish === 'function') {
        S.analytics.publish('plentum_funnel_click', { slot: a.getAttribute('data-funnel'), formula: a.getAttribute('data-funnel-formula') || '', page: window.location.pathname, href: a.getAttribute('href') || '' });
      }
    } catch (err) {}
  }, true);
})();
